import { EntryLayout } from '@all-manager/design-system-v2';
import { PropsWithChildren, ReactNode } from 'react';
import BrandLogo from '../../components/BrandLogo/BrandLogo';
import { APP_TAGLINE, APP_TITLE } from '../../constants/app';
import { useAuthLayout } from './useAuthLayout';

type Props = {
  title: string;
  description?: ReactNode;
  /** `wide` for a list of choices (space selection), `narrow` (default) for a form. */
  width?: 'narrow' | 'wide';
  /** `plain` when the content brings its own cards. */
  surface?: 'card' | 'plain';
};

/** Frame of the screens shown outside the space shell: sign-in, password recovery, space selection. */
export default function AuthLayout(props: PropsWithChildren<Props>) {
  useAuthLayout(props);

  return (
    <EntryLayout
      brand={{ name: APP_TITLE, tagline: APP_TAGLINE, logo: <BrandLogo /> }}
      title={props.title}
      description={props.description}
      width={props.width}
      surface={props.surface}
    >
      {props.children}
    </EntryLayout>
  );
}
